module.exports = __webpack_public_path__ + "img/boy-homework.b7af28fe.png";